import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/Login.vue'
import Main from '@/views/main/Index.vue'
import Home from '@/views/main/home/Home.vue'
import Cutsomer from '@/views/main/customer/Customer.vue'
import Order from '@/views/main/order/Order.vue'
import OrderApply from '@/views/main/order/OrderApply.vue'
import OrderDetail from '@/views/main/order/OrderDetail.vue'
import Coupon from '@/views/main/operate/Coupon.vue'
import Feedback from '@/views/main/operate/Feedback.vue'
import Register from '@/views/main/customer/Register.vue'
import System from '@/views/main/system/System.vue'
import Stock from '@/views/main/stock/Stock.vue'
import OrderDeliveryPackage from '@/views/main/order/OrderDeliveryPackage.vue'
import Refund from '@/views/main/order/Refund.vue'
import Dashboard from '@/views/main/dashboard/Index.vue'
import DashboardOld from '@/views/main/dashboard/IndexOld.vue'
import FinanceOrder from '@/views/main/finance/List.vue'
import FinanceOrderDetail from '@/views/main/finance/Detail.vue'
import FinanceAfterSale from '@/views/main/finance/AfterSale.vue'
import ZpcHelper from '@/views/main/system/Helper.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Main,
      children: [
        {
          path: '/dashboard',
          alias: '/',
          meta: {
            title: '工作台',
            code: 'm.dashboard'
          },
          component: Dashboard
        },
        {
          path: '/dashboard/old',
          meta: {
            title: '工作台',
            code: 'm.dashboard'
          },
          component: DashboardOld
        },
        {
          path: 'home',
          meta: {
            title: '控制台',
            code: 'm.home'
          },
          component: Home
        },
        {
          path: 'financeorder',
          component: FinanceOrder,
          meta: {
            title: '客户订单',
            code: 'm.financeorder'
          }
        },
        {
          path: 'financeorder/:id',
          component: FinanceOrderDetail,
          meta: {
            title: '客户订单',
            code: 'm.financeorder'
          }
        },
        {
          path: 'financeaftersale',
          component: FinanceAfterSale,
          meta: {
            title: '客户售后',
            code: 'm.financeaftersale'
          }
        },
        {
          path: 'customer',
          component: Cutsomer,
          meta: {
            title: '客户管理',
            code: 'm.customer'
          }
        },
        {
          path: 'customer/add',
          component: Register,
          meta: {
            title: '客户管理',
            code: 'm.customer'
          }
        },
        {
          path: 'operate/coupon',
          component: Coupon,
          meta: {
            title: '运营管理.优惠券',
            code: 'm.operate.coupon'
          }
        },
        {
          path: 'operate/feedback',
          component: Feedback,
          meta: {
            title: '运营管理.客户反馈',
            code: 'm.operate.feedback'
          }
        },
        {
          path: 'order/list',
          component: Order,
          meta: {
            title: '订单列表',
            code: 'm.order.list'
          }
        },
        {
          path: 'order/create',
          component: OrderApply,
          meta: {
            title: '订单审批',
            code: 'm.order.create'
          }
        },
        {
          path: 'order/package',
          component: OrderDeliveryPackage,
          meta: {
            title: '出库记录',
            code: 'm.order.package'
          }
        },
        {
          path: 'order/refund',
          component: Refund,
          meta: {
            title: '售后列表',
            code: 'm.order.refund'
          }
        },
        {
          path: 'order/detail/:id',
          component: OrderDetail,
          meta: {
            title: '订单管理.订单详情',
            code: 'm.order.detail'
          }
        },
        {
          path: 'system/privilege',
          component: System,
          meta: {
            title: '权限管理',
            code: 'm.system'
          }
        },
        {
          path: 'stock',
          component: Stock,
          meta: {
            title: '权限管理',
            code: 'm.stock'
          }
        },
        {
          path: 'zpchelper',
          component: ZpcHelper,
          meta: {
            title: '辅助功能',
            code: 'm.zpchelper'
          }
        },
        {
          path: '*',
          component: Vue.extend({
            template: `<div>404</div>`
          })
        }
      ]
    }
  ]
})

export default router
